module.exports = __webpack_public_path__ + "img/menu.ec0ccaff.svg";